@if (isPopup()) {
  @defer {
    <ng-container *ngTemplateOutlet="content"></ng-container>
  } @placeholder {
    <div #placeholder class="flex justify-center items-center h-[100vh] w-full">
      <progress-bar></progress-bar>
    </div>
  }
} @else {
  <ng-container *ngTemplateOutlet="content"></ng-container>
}

<ng-template #content>
  <mat-tab-group
    class="popup-card !p-0 w-full tabs-fill"
    [ngClass]="{ 'tab-flex': !isPopup() }"
  >
    @for (tab of productData() | keyvalue: keepOriginalOrder; track tab) {
      <mat-tab [label]="tab.key.toString()" class="leading-6">
        <div class="md:p-[15px] p-[5px]">
          @switch (tab.key) {
            @case ('description') {
              <ng-container
                class="bg-[#F94D00] p-[10px] text-center text-[14px] text-[#ffffff] font-bold uppercase cursor-pointer"
                *ngTemplateOutlet="description; context: { $implicit: tab }"
              >
              </ng-container>
            }
            @case ('specifications') {
              <ng-container
                *ngTemplateOutlet="specifications; context: { $implicit: tab }"
              >
              </ng-container>
            }
          }
        </div>
      </mat-tab>
    }
  </mat-tab-group>
</ng-template>

<ng-template #description let-tab>
  <div
    class="md:text-[13px] text-[13px] leading-[20px] whitespace-nowrap text-wrap break-words detail-text"
    [ngClass]="{ 'h-[147px]': !showTable() }"
    [innerHtml]="tab.value"
  >
    <!-- {{  }} -->
  </div>
</ng-template>

<ng-template #specifications let-tab>
  @if (showTable()) {
    <table class="min-w-full bg-white shadow-md rounded-md text-[14px]">
      <thead></thead>
      <tbody class="text-blue-gray-900">
        @for (attribute of tab?.value | keys; track attribute; let i = $index) {
          <tr
            class="border-b border-blue-gray-200"
            [ngClass]="{ 'bg-[#F0F0F0]': i % 2 === 0 }"
          >
            <td
              class="md:py-3 md:px-4 p-[5px] md:leading-[21px] leading-[16px] md:text-[14px] text-[13px]"
            >
              <h2 class="font-normal text-[13px] m-[0px]">
                {{ attribute.key }}
              </h2>
            </td>
            <td
              class="md:py-3 md:px-4 p-[5px] md:leading-[21px] leading-[16px] md:text-[14px] text-[13px]"
            >
              <h3 class="font-normal text-[13px] m-[0px]">
                {{ attribute.value }}
              </h3>
            </td>
          </tr>
        }
      </tbody>
    </table>
  } @else {
    <div
      class="flex flex-wrap md:flex gap-[9px]"
      [ngClass]="{ 'h-[147px]': !showTable() }"
    >
      <div class="w-full">
        <div class="flex flex-wrap gap-[7px]">
          @for (
            attribute of tab?.value | keys;
            track attribute;
            let i = $index
          ) {
            <div
              class="flex items-center gap-[4px] border border-solid border-[#DFDFDF] p-[6px] rounded-sm flex-nowrap"
            >
              <img
                [ngSrc]="slotData()?.widget?.data?.value?.greenCheckImage?.url"
                [height]="
                  slotData()?.widget?.data?.value?.greenCheckImage?.height
                "
                [width]="
                  slotData()?.widget?.data?.value?.greenCheckImage?.width
                "
                [alt]="slotData()?.widget?.data?.value?.greenCheckImage?.alt"
                [title]="slotData()?.widget?.data?.value?.greenCheckImage?.alt"
                class="!w-[12px] !h-[12px] items-center object-contain"
              />
              <h2
                class="text-[#5B5B5B] md:text-[14px] text-[12px] font-normal m-[0px]"
              >
                {{ attribute.key }} : {{ attribute.value }}
              </h2>
            </div>
          }
        </div>
      </div>
    </div>
  }
</ng-template>
